var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Check } from 'pcln-icons';
import { Button } from '../Button';
import { Text } from '../Text';
import { getPaletteColor } from '../utils';
var StepperFlex = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  background-color: ", ";\n  color: ", ";\n  cursor: ", ";\n  padding: 0;\n  font-weight: unset;\n\n  &:hover {\n    background-color: ", ";\n  }\n"], ["\n  display: flex;\n  background-color: ", ";\n  color: ", ";\n  cursor: ", ";\n  padding: 0;\n  font-weight: unset;\n\n  &:hover {\n    background-color: ", ";\n  }\n"])), getPaletteColor('background.lightest'), getPaletteColor('base'), function (props) { return (props.onClick ? 'pointer' : 'default'); }, getPaletteColor('background.lightest'));
var propTypes = {
    className: PropTypes.string,
    active: PropTypes.bool,
    completed: PropTypes.bool,
    children: PropTypes.node.isRequired,
    onClick: PropTypes.func,
};
var Step = function (_a) {
    var className = _a.className, active = _a.active, completed = _a.completed, children = _a.children, onClick = _a.onClick, props = __rest(_a, ["className", "active", "completed", "children", "onClick"]);
    var color = active || completed ? 'primary' : 'text.light';
    return (React.createElement(StepperFlex, __assign({ className: className, alignItems: 'center', onClick: onClick }, props),
        completed && (React.createElement(Check, { color: 'primary', size: 16, mr: 1, "aria-hidden": false, "aria-label": 'Step Completed' })),
        React.createElement(Text, { color: color, bold: active, fontSize: 1, "aria-selected": active }, children)));
};
Step.displayName = 'Step';
Step.propTypes = propTypes;
Step.defaultProps = {
    className: '',
    active: false,
    completed: false,
};
export default Step;
var templateObject_1;
//# sourceMappingURL=Step.js.map